import React from 'react';
import File from 'lib/components/file/File';
import CsvImport from 'lib/components/csv-import/CsvImport';
import useCsvImport from 'lib/useCsvImport';
import ImportResult from 'lib/components/import-error/ImportResult';

import './ImportQuestionDefectsPage.scss';

const columnLabels = {
  questionId: 'Question External ID',
  questionExternalId: 'Question External ID',
  defectExternalId: 'Defect External ID',
  defectWeight: 'Defect Weight',
  defectId: 'Defect ID',
};

const defectErrorValidations = {
  question: {
    'question.notFound': () => 'Could not find question',
    'answerType.wrongValue': () =>
      'Text area, date and quantitative input questions do not support defects',
  },
  defect: {
    'defect.notFound': () => 'Could not find defect',
  },
  defectId: {},
  weight: {},
};

export default function ImportQuestionDefectsPage(props) {
  const { ...list } = useCsvImport(props);

  return (
    <div className='settings-import-question-defects-page'>
      <h4>Import question defects</h4>
      <p className='form-info'>
        Before importing defects, please make sure you structure your data like
        in the example CSV to minimize importing errors.
      </p>
      <div className='document'>
        <a
          href='documents/sample-question-defects.csv'
          target='_blank'
          download
        >
          <File data={{ name: 'Example CSV', type: 'text/csv' }} />
        </a>
      </div>
      <CsvImport type='question-defects' onUploadInfo={list.uploadInfo} />
      <ImportResult
        list={list}
        errorValidations={defectErrorValidations}
        columnLabels={columnLabels}
      />
    </div>
  );
}
